import script from "./Brand.vue?vue&type=script&setup=true&lang=js"
export * from "./Brand.vue?vue&type=script&setup=true&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=e3550a2a&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3550a2a"]])

export default __exports__